import React,{Component} from "react";
import { Row, Col, Card, CardHeader, Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormSelect,
  Form,
  FormGroup,
  FormInput,
  DatePicker,
   ListGroup,
   ListGroupItem
   
  } from "shards-react";


import firebase from '../firebase';
import { toast } from 'react-toastify';
import { AtomSpinner } from 'react-epic-spinners';
import CustomFileUpload from './FileUpload';


const state_backup = {
      dateofadmission: undefined,
      dob:undefined,
      name:undefined,
      photo_url:undefined,
      father_name:undefined,
      mother_name:undefined,
      class:undefined,
      gender:undefined,
      roll_no:undefined,
      phone:undefined,
      address:undefined,

      class_list:[],
      loading:false

    };

export default class AddStudent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      dateofadmission: undefined,
      dob:undefined,
      name:undefined,
      photo_url:undefined,
      father_name:undefined,
      mother_name:undefined,
      class:undefined,
      gender:undefined,
      roll_no:undefined,
      phone:undefined,
      address:undefined,

      class_list:[],
      loading:false

    };

    this.handleDOBDateChange = this.handleDOBDateChange.bind(this);
    this.handleDateofAdmission = this.handleDateofAdmission.bind(this);
    this.get_class_list = this.get_class_list.bind(this);
    this.updateurl = this.updateurl.bind(this);
    this.checkIsNotNull = this.checkIsNotNull.bind(this);
    this.add_student = this.add_student.bind(this);
    this.convertDate = this.convertDate.bind(this);
    this.get_data = this.get_data.bind(this);
  }

  get_class_list = ()=>{
    this.setState({class_list:this.props.class_list});
  }


  componentDidMount(){
    this.get_class_list();
  }

  updateurl = (url)=>{
    this.setState({photo_url:url});
  }

  handleDOBDateChange(value) {
    this.setState({ dob: new Date(value)});
  }

  handleDateofAdmission(value) {
    this.setState({ dateofadmission: new Date(value)});
  }

  convertDate(date){
      var dd = date.getDate();
      var mm = date.getMonth();
      var yyyy = date.getFullYear();

      if(dd<10){
        dd = "0"+dd;
      }
      if(mm<10){
        mm = "0"+mm;
      }

      return yyyy+"-"+mm+"-"+dd;
  }

  checkIsNotNull = (p) =>{
    for (var key in p) {
        if (p.hasOwnProperty(key)) {
          if(p[key]===undefined){
            return false;
          }
          if(key === "class"){
            if(p[key]==="Select Class"){
              return false;
            }
          }
          if(key === "gender"){
            if(p[key]==="Select Gender"){
              return false;
            }
          }
        }
    }
    return true;
  }

  get_data = () =>{
    var data = {
      dateofadmission: this.convertDate(this.state.dateofadmission),
      dob: this.convertDate(this.state.dob),
      name:this.state.name,
      photo_url:this.state.photo_url,
      father_name:this.state.father_name,
      mother_name:this.state.mother_name,
      class:this.state.class,
      gender:this.state.gender,
      roll_no:this.state.roll_no,
      phone:this.state.phone,
      address:this.state.address,
    }

    return data;
  }

 

  add_student =(evt)=>{
     var that = this;
      evt.preventDefault();

      
       var func_ref = firebase.functions().httpsCallable('AddStudent');  

       if(this.checkIsNotNull(this.state)){                     
          
        this.setState({loading:true});
        var data = this.get_data();      

       func_ref(data).then(function(result) {
                  // Read result of the Cloud Function.
                  var data = result.data;
                  console.log(data);
                  if(data.status==="success"){
                        console.log("Document succesfully added!");
                        toast('Student  Added Successfully !', {containerId: 'A'});

                   }
                  else{
                        toast(data.error.message, {containerId: 'A'});
                        console.log(data.error.message);
                  }
                  that.setState(state_backup);
                  that.setState({class_list:that.props.class_list})

        }).catch(function(error) {
                  // Getting the Error details.
                  //var code = error.code;
                  //var message = error.message;
                  //var details = error.details;
                  // ...
                  console.log(error);
                  that.setState({loading:false});
                  toast("unable to add Student", {containerId: 'A'});
        });

      }
      else{

              toast('Please fill all detials!', {containerId: 'A'});
      }
  }


  render(){
    return(
       <Card small className="mb-4">
    <CardHeader className="border-bottom">
      <h6 className="m-0">Add New Student</h6>
    </CardHeader>
    <ListGroup flush>
      <ListGroupItem className="p-3">
        <Row>
          <Col>
            {
              !this.state.loading &&
            
            <Form onSubmit={this.add_student}>
              <Row>
                  

                  <Col md="6" className="form-group">
                  <label htmlFor="feFirstName">Student Name</label>
                  <FormInput
                    id="feFirstName"
                    placeholder="Name"
                    onChange={(evt) => {this.setState({name:evt.target.value})}}
                  />
                </Col>

                <Col md="6" className="form-group">
                    <label htmlFor="feFileUpload">Profile Photo</label>
                    { 
                      (this.state.photo_url===undefined) &&
                      <CustomFileUpload update_url={this.updateurl}/>
                    }
                    {
                      (this.state.photo_url!==undefined) &&
                      <Col>
                      <Button theme="danger" size="sm" onClick={()=>{this.setState({photo_url:undefined})}}>
                            Remove
                      </Button>
                      </Col>
                    }
                  </Col>
              </Row>
              <Row form>
                {/* First Name */}
                <Col md="6" className="form-group">
                  <label htmlFor="feFirstName">Father Name</label>
                  <FormInput
                    id="feFirstName"
                    placeholder="Father Name"
                    onChange={(evt) => {this.setState({father_name:evt.target.value})}}
                  />
                </Col>
                {/* Last Name */}
                <Col md="6" className="form-group">
                  <label htmlFor="feLastName">Mother Name</label>
                  <FormInput
                    id="feLastName"
                    placeholder="Mother Name"
                    onChange={(evt) => {this.setState({mother_name:evt.target.value})}}
                  />
                </Col>
              </Row>
              <Row form>
                {/* Email */}
                <Col md="4" className="form-group">
                  <label htmlFor="fePassword">DOB</label>
                  
                    <InputGroup>
                        <DatePicker
                            size="ld"
                            selected={this.state.dob}
                            onChange={this.handleDOBDateChange}
                            placeholderText="Pick Date"
                            dropdownMode="select"
                            className="text-center"
                          />
                      <InputGroupAddon type="append">
                            <InputGroupText>
                                  <i className="material-icons">&#xE916;</i>
                            </InputGroupText>
                      </InputGroupAddon>
                  </InputGroup>
                
              </Col>
                <Col md="4" className="form-group">
                  <label htmlFor="feEmail">Class</label>
                  <FormSelect onChange={(evt) => {this.setState({class:evt.target.value})}}>
                        <option>Select Class</option>
                        {

                          this.state.class_list.map((item,i)=>{
                            return (<option key={i}>{item}</option>)
                          })
                        }
                  </FormSelect>
                </Col>
                {/* Password */}
                <Col md="4" className="form-group">
                  <label htmlFor="fePassword">Gender</label>
                  <FormSelect onChange={(evt) => {this.setState({gender:evt.target.value})}}>
                        <option>Select Gender</option>
                        <option>Male</option>
                        <option>Female</option>
                  </FormSelect>

                </Col>
                
              </Row>
              <Row form> 
                  <Col md="4" className="form-group">
                  <label htmlFor="fePassword">Date of Admission</label>                  
                    <InputGroup>
                        <DatePicker
                            size="ld"
                            selected={this.state.dateofadmission}
                            onChange={this.handleDateofAdmission}
                            placeholderText="Pick Date"
                            dropdownMode="select"
                            className="text-center"
                          />
                      <InputGroupAddon type="append">
                            <InputGroupText>
                                  <i className="material-icons">&#xE916;</i>
                            </InputGroupText>
                      </InputGroupAddon>
                  </InputGroup>                
                </Col>

                <Col md="4" className="form-group">
                  <label htmlFor="feLastName">Roll No.</label>
                  <FormInput
                    id="feLastName"
                    placeholder="Roll No."
                    onChange={(evt) => {this.setState({roll_no:evt.target.value})}}
                  />
                </Col>

                <Col md="4" className="form-group">
                  <label htmlFor="feLastName">Phone No.</label>
                  <FormInput
                    id="feLastName"
                    placeholder="Phone (comma seperated)"
                    onChange={(evt) => {this.setState({phone:evt.target.value})}}
                  />
                </Col>


              </Row>
              <FormGroup>
                <label htmlFor="feAddress">Address</label>
                <FormInput
                  id="feAddress"
                  placeholder="Address"
                  onChange={(evt) => {this.setState({address:evt.target.value})}}
                />
              </FormGroup>
                            
              <Button theme="accent">Add Student</Button>
              <Button type="button" style={{marginLeft: '5%'}} theme="danger" onClick={()=>this.props.cancel()}>Cancel</Button>
            </Form>

          }
          { 
              
                  (this.state.loading) &&
                    <div style={{margin: '10%',marginLeft: '40%'}}>
                        <AtomSpinner color="blue" />            
                    </div>
          

          }
          </Col>
        </Row>
      </ListGroupItem>
    </ListGroup>
  </Card>
    )
  }
}

